import { useEffect } from "react";
import { useApp } from "./context/AppContext";
import { HomeScreen } from "./components/HomeScreen";
import { DraftScreen } from "./components/DraftScreen";
import BattleScreen from "./components/BattleScreen";
import { CollectionScreen } from "./screens/CollectionScreen";
import { Header } from "./components/Header";
import Footer from "./components/Footer";
import { ToastContainer } from "./components/Toast";

import { audioManager } from "./utils/audioManager";

export function App() {
  const { state } = useApp();

  useEffect(() => {
    audioManager.toggleMusic(state.audio.musicEnabled);
    audioManager.toggleSFX(state.audio.sfxEnabled);
  }, [state.audio.musicEnabled, state.audio.sfxEnabled]);

  const renderScreen = () => {
    switch (state.screen) {
      case "home":
        return <HomeScreen />;
      case "draft":
        return <DraftScreen />;
      case "battle":
        return <BattleScreen />;
      case "collection":
        return <CollectionScreen />;
      default:
        return <HomeScreen />;
    }
  };

  return (
    <div className="h-screen flex flex-col bg-gradient-to-b from-poke-blue-darker to-poke-blue-dark overflow-hidden">
      <Header />
      <main className="flex-1 min-h-0 overflow-auto">
        <div key={state.screen} className="screen-enter h-full">
          {renderScreen()}
        </div>
      </main>
      <Footer />
      <ToastContainer />
    </div>
  );
}
